module.exports = __webpack_public_path__ + "static/media/communication_image.cd9d37cc.png";